import React, { useState, useEffect } from "react";
import { getCollegeProgramDates } from "../../services/studentportalapis";

const DownloadCertificate = ({ completionPercentage }) => {
  
  const [collegeId] = useState(
      JSON.parse(localStorage.getItem("student-details"))["collegeId"]
    );

   const [programStartDate] = useState(
      JSON.parse(localStorage.getItem("student-details"))["programStartDate"]
    );
  
     const [programEndDate] = useState(
      JSON.parse(localStorage.getItem("student-details"))["programEndDate"]
    );

    
  const [isEligible, setIsEligible] = useState(false);

  useEffect(() => {
    const checkEligibility = async () => {
      try {
        // const { programStartDate, programEndDate } = await getCollegeProgramDates(collegeId);
//         const programStartDate = '2025-01-01';
// const programEndDate = '2025-06-31';

   
        const today = new Date();
        const start = new Date(programStartDate);
      
        const end = new Date(programEndDate);
       

        const withinRange = today >= start && today <= end;
        setIsEligible(completionPercentage === 100 && withinRange);
        console.log("abc"+ withinRange);
      } catch (error) {
        console.error('Error fetching program dates:', error);
        setIsEligible(false);
      }
    };

    if (completionPercentage === 100) {
      checkEligibility();
    }
  }, [completionPercentage, collegeId]);

  return (
    <div className="text-center mt-6">
      <button
        className={`px-12 py-2 rounded-full text-white font-semibold text-lg transition-all duration-300 ${
          isEligible ? "bg-green-600 hover:bg-green-500" : "bg-gray-400 cursor-not-allowed"
        }`}
        disabled={!isEligible}
      >
        <span className="block">Agivant's AI Amplified</span>
        <span className="block">Software Engineering</span>
      </button>
    </div>
  );
};

export default DownloadCertificate;